import { gql } from '@apollo/client'

export const createPifAttributionMutation = gql`
  mutation createPifAttribution($input: CreatePifAttributionInput!) {
    createPifAttribution(input: $input) {
      benefactorAttributionRollup {
        id
        firstName
        lastName
        country
        city
        state
        user {
          uuid
          profile {
            id
            firstName
            lastName
            image(fallbackToInitials: true)
          }
        }
      }
      showCta
    }
  }
`
